import router from './router'
import ExpensesMessages from './localization'

export default {
  router,
  localization: ExpensesMessages,
}
